import { StatelessComponent } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/atoms/buttons/CloseButton.css'
import Icon from 'components/atoms/Icon'
import { QAMarked } from 'interfaces/component'

type CloseProps = QAMarked & {
  size?: 'small' | 'medium'
  theme?: 'dark' | 'light' | 'danger' | 'warning' | 'success' | 'action'
  onClick?: () => void
}

const CloseButton: StatelessComponent<CloseProps> = (props) => {
  const { theme, onClick, size, qaMarker } = props

  const buttonClassname = cn(styles.closeButton, {
    [styles.small]: size === 'small',
    [styles.light]: theme === 'light',
    [styles.danger]: theme === 'danger',
    [styles.warning]: theme === 'warning',
    [styles.success]: theme === 'success',
    [styles.action]: theme === 'action',
  })

  return (
    <button
      data-qa-marker={ qaMarker }
      className={ buttonClassname }
      onClick={ onClick }
    >
      <Icon kind='close' />
    </button>
  )
}

CloseButton.defaultProps = {
  theme: 'dark',
  size: 'medium',
}

export default CloseButton
